export const PEER_REVIEWS = [
    {
        project: "Devtion",
        body: `올라운더 육각형 플레이어. no doubt.
1팀의 유일한 E로서 항상 가장 적극적인 태도에 대해 진심으로 감사합니다.`,
    },
    {
        project: "Devtion",
        body: `본인이 맡은 파트는 완벽히 해냈고 다른 파트를 도와주지 못해서 아쉽다면서 문서작업까지 직접 해주셔서 너무 좋았습니다.`,
    },
    {
        project: "Devtion",
        body: `먼저 나서서 아직 진행하지 못한 부분 찾아서 진행해주시고 개발 속도도 빠르신 것 같습니다.
이번 프로젝트에 기여를 많이 해주셔서 잘 마무리 할 수 있었던 것 같아요. 감사합니다!`,
    },
    {
        project: "De:caffeine",
        body: `코드리뷰나 깃허브에서 pr할때 제일 잘 코드를 잘 봐주고 코드에서 보이는 단점과 피드백을 잘 해주신 것 같아서 도움이 많이 되었다.
프로젝트를 진행하는동안에 성실하게 진행하는것이 느껴졌고 팀원의 모르는 부분까지 잘 도와준 것 같다.`,
    },
    {
        project: "De:caffeine",
        body: `매의눈, 꼼꼼함, 적극적`,
    },
    {
        project: "De:caffeine",
        body: `질문하면 친절히 알려주셔서 매우 감사하고 있습니다 :)`,
    },
    {
        project: "북적북적",
        body: `작업 속도가 빠르시고 github나 툴들을 사용하시는데 막힘 없으십니다.
프로젝트를 진행하면서 모르는 부분에 대해서 배울려는 태도나 본인이 아는 지식을 공유할려는 모습이 인상적이였습니다.
수고하셨습니다`,
    },
    {
        project: "북적북적",
        body: `프로젝트를 진행하면서 충분한 소통과 많은 피드백을 해 주어서 프로젝트 진행에 많은 도움이 되었습니다`,
    },
    {
        project: "북적북적",
        body: `의견도 많이 내주시고 열심히 하는 모습 보기 좋습니다`,
    },
    {
        project: "Studium",
        body: `책임감을 가지고 일을 끝내시려는 모습이 인상 깊었습니다.
또한, 적극적으로 아이디어를 제시해주고 저보다는 기술 역량이 뛰어난 분이라고 느꼈습니다.
원활하게 프로젝트를 진행할 수 있게 많은 부분에서 기여해 주신 점 너무 감사합니다.`,
    },
    {
        project: "Studium",
        body: `의욕이 뛰어나고 이런저런 의견을 잘 제시하고 적극적이었습니다.
디자인적인 부분에서 디테일한 부분을 잘 짚어주시고, 코드리뷰를 꼼꼼하게 해주신 점이 저에게는 큰 도움이 되었어요.
감사하고 고생하셨어요
`,
    },
    {
        project: "Studium",
        body: `피드백 너무 잘해주셔서 도움이 많이 되었습니다`,
    },
];
